import LOCAL_KEYS, {
    parseLocalStorageJSON,
  } from "../../../helpers/Localstorage";
  import { RequestBody } from "../../WebServiceManager/RequestBody";
  import { RequestHeader } from "../../WebServiceManager/RequestHeader";
  
  export default class InvoiceRequestBody {

    invoiceListRequest(method) {
        const header = new RequestHeader();
        const request = new RequestBody(
          method,
          header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN))
        );
        return request;
      }
      updateInvoiceRequest (method,obj) {
        const header = new RequestHeader();
        const request = new RequestBody(
          method,
          header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
          obj
        );
        return request;
      }

      reGenerateInvoicePDFRequest(obj,method) {
        const header = new RequestHeader();
        const request = new RequestBody(
          method,
          header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
          obj
        );
        return request;
      }

      invoicePaymentDateRequest(method,obj) {
        const header = new RequestHeader();
        const request = new RequestBody(
          method,
          header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
          obj
        );
        return request;
      }
  }

  